/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFlashlight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m14.83 18.416 2 3-1.663 1.11-2-3zm2.876-2.152 3 3-1.414 1.414-3-3zM7.243 3l4.774 4.751 7.681 2.56-9.358 9.36-2.558-7.67L3 7.241A3.002 3.002 0 0 1 3 3c1.133-1.133 3.109-1.133 4.243 0zm4.511 6.773L9.8 11.727l1.415 4.242 4.782-4.782zm7.561 3.25 3 1-.633 1.896-3-1zM5.121 4.121a1 1 0 0 0-.707 1.707l4.242 4.214 1.413-1.414-4.241-4.214a.993.993 0 0 0-.707-.293z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFlashlight as Flashlight };
